import * as React from "react";
import SwipeableViews from "react-swipeable-views";
import { WBSStore } from "modules/WBS/WBSStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import TakeOffItemProperties from "modules/takeOff/components/layouts/TakeOffItemProperties";
import { observer } from "mobx-react";
import Tab1 from "modules/projectRightMenu/components/layouts/Tab1";
import ModelMapLateralMenu from "modules/modelMap/components/ModelMapLateralMenu";
import Tab3 from "modules/activitySearch/components/pages/ActivitySearch";
import { AppBar, Tabs, Tab, Typography, withStyles } from "@material-ui/core";
import { BarChart, Map, GroupWork, Help } from "@material-ui/icons";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";

const styles = (theme) => ({
  tabsRoot: {
    minHeight: "unset",
    backgroundColor: "#000",
  },
  tabRoot: {
    minWidth: "unset",
    minHeight: "33px",
    flexGrow: 1,
    color: "#8c8c8c",
  },
  tabSelected: {
    backgroundColor: "#2E2E2E",
    color: "#fff",
  },
  icon: {
    fontSize: "18px",
    "&:hover": {
      color: "#FFFFFF",
    },
    transition: "all 0.3s ease-in",
  },
  iconBadge: {
    fontSize: "12px",
    color: "#FFF700",
    position: "absolute" as any,
    marginTop: "2px",
  },
  swipeableViews: {
    background: "#2A292F",
    height: "calc(100% - 33px)",
    position: "relative" as any,
  },
  tabContainer: {
    overflow: "hidden",
  },
});

function TabContainer({ children, ...props }) {
  return (
    <Typography component="div" {...props}>
      {children}
    </Typography>
  );
}

type IProps = {
  classes: any;
};

@observer
class ProjectRightMenu extends React.Component<IProps> {
  handleTabChange = (event, tab) => {
    if (tab === 3) {
      event.stopPropagation();
      window.open(
        "https://megasistemas.atlassian.net/wiki/spaces/helprubk/overview"
      );
    } else {
      WBSStore.rightMenuTab = tab;
    }
  };

  render() {
    const { classes } = this.props,
      tabClasses = { root: classes.tabRoot, selected: classes.tabSelected };
    let error = false;
    let warning = false;
    for (let i = 0; i < ModelMapStore.modelMapsView.length; i++) {
      const element = ModelMapStore.modelMapsView[i];
      if (element.data.filterErrors && element.data.filterErrors.length > 0) {
        error = true;
        break;
      }
      if (element.data.formatErrors && element.data.formatErrors.length > 0) {
        error = true;
        break;
      }
      if (element.data.modelErrors && element.data.modelErrors.length > 0) {
        error = true;
        break;
      }
      if (
        element.data.categoryErrors &&
        element.data.categoryErrors.length > 0
      ) {
        error = true;
        break;
      }
    }
    if (
      ModelMapStore.modelMaps.filter((e) => e.data.warning == true).length > 0
    ) {
      warning = true;
    }
    return (
      <div>
        <AppBar position="static" color="default">
          <Tabs
            classes={{ root: classes.tabsRoot }}
            value={WBSStore.rightMenuTab}
            onChange={this.handleTabChange}
          >
            <Tab
              classes={tabClasses}
              icon={<BarChart className={classes.icon} />}
            />
            <Tab
              classes={tabClasses}
              icon={
                <div>
                  <Map className={classes.icon} style={{ marginTop: "8px" }} />{" "}
                  {error == true ? (
                    <FiberManualRecordIcon
                      style={{ color: "#FB4436" }}
                      className={classes.iconBadge}
                    />
                  ) : ModelMapStore.currentWbsNeedToBeUpdated == true ? (
                    <FiberManualRecordIcon className={classes.iconBadge} />
                  ) : (
                    <></>
                  )}
                </div>
              }
            />
            <Tab
              classes={tabClasses}
              icon={<GroupWork className={classes.icon} />}
            />
            <Tab
              classes={tabClasses}
              icon={<Help className={classes.icon} />}
            />
          </Tabs>
        </AppBar>

        <SwipeableViews
          axis={"x"}
          index={WBSStore.rightMenuTab}
          disabled={true}
          className={classes.swipeableViews}
        >
          <TabContainer className={classes.tabContainer}>
            {TakeOffStore.layerTakeOffList && <TakeOffItemProperties />}
            <Tab1 />
          </TabContainer>
          <TabContainer>
            <ModelMapLateralMenu />
          </TabContainer>
          <TabContainer>
            <Tab3 />
          </TabContainer>
        </SwipeableViews>
      </div>
    );
  }
}
export default withStyles(styles)(ProjectRightMenu);



// WEBPACK FOOTER //
// ./src/modules/projectRightMenu/components/pages/ProjectRightMenu.tsx